import React from "react";
import {
  getBranchSalesPerson,
  deactivateSalesPerson,
} from "../../../api/salespersons";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";
import IconButton from "../../../_components/IconButton";
import TableData from "../../../_components/TableData";
import LoadingContainer from "../../../_components/LoadingContainer";
import { formatPhoneNumber } from "../../../utils";
import Modal from "../../../_components/Modal";

import { toast } from "react-toastify";

import styled from "styled-components";

const ButtonsGroup = styled.div`
  display: flex;
  justify-content: space-around;
`;

export default (props) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [show, setShow] = React.useState(false);
  const [loadingDeactivate, setLoadingDeactivate] = React.useState(false);
  const [salesperson, setSalesPerson] = React.useState(undefined);

  const handleCloseModal = () => {
    if (loadingDeactivate) {
      return;
    }
    setSalesPerson(undefined);
    setShow(false);
  };

  const handleDeactivate = () => {
    setLoadingDeactivate(true);
    deactivateSalesPerson(salesperson)
      .then(() => {
        toast.success("Vendedor Desativado!", {
          toastId: "salesperson-deactivated",
          position:"top-center"
        });
        setTimeout(() => {
          window.location.reload();
        }, 1890);
      })
      .finally(() => {
        setTimeout(() => {
          setLoadingDeactivate(false);
        }, 2000);
      });
  };

  function getSallersPerson() {
    getBranchSalesPerson()
      .then((data) => {
        for (let x in data) {
          data[x]["phone_number"] = formatPhoneNumber(data[x]["phone_number"]);
          data[x]["actions"] = (
            <ButtonsGroup>
              <IconButton
                icon="ban"
                onClick={() => {
                  setShow(true);
                  setSalesPerson(data[x]["id"]);
                }}
              />
              <IconButton
                onClick={(item) => {
                  window.location.href = `/salespersons/${data[x]["id"]}`;
                }}
                icon="edit"
              />
            </ButtonsGroup>
          );
        }
        setData(data);
        setTimeout(() => {
          setLoading(false);
        }, 1200);
      })
      .catch();
  }

  React.useEffect(getSallersPerson, []);

  return (
    <LoadingContainer loading={loading}>
      <div className="container-fuild">
        <div className="row">
          <div className="col-12">
            <Text>Vendedores</Text>
            <Button
              onClick={() => {
                window.location.href = "/salesperson/create";
              }}
            >
              Cadastrar vendedor
            </Button>
          </div>
        </div>
        <TableData
          data={data}
          tBodyKeys={["name", "email", "phone_number", "actions"]}
          tHead={["Nome", "E-mail", "Telefone", "Ações"]}
        />
      </div>
      <Modal title="Desativar Vendedor" show={show} onHide={handleCloseModal}>
        <Text fontSize="md" align="center">
          Deseja mesmo desativer este vendedor?
        </Text>
        <Text fontSize="sm" align="center">
          O acesso do vendedor será suspenso, porém seu histórico de vendas será
          mantido.
        </Text>
        <div className="d-flex justify-content-center mt-3">
          <Button disabled={loadingDeactivate} onClick={handleDeactivate}>
            Confirmar
          </Button>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <Button
            disabled={loadingDeactivate}
            onClick={handleCloseModal}
            color="danger"
            as="text"
          >
            Cancelar
          </Button>
        </div>
      </Modal>
    </LoadingContainer>
  );
};



// WEBPACK FOOTER //
// ./src/views/SalesPersons/List/index.jsx